"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#356EE9",
  fillRule: "evenodd",
  d: "M7.399 19.607a1.708 1.708 0 0 1-2.243.888 1.7 1.7 0 0 1-.89-2.237c.373-.863 2.95-2.517 2.95-2.517s.557 3.003.183 3.866Zm5.287 0a1.708 1.708 0 0 1-2.242.888 1.7 1.7 0 0 1-.892-2.237c.374-.863 2.95-2.517 2.95-2.517s.558 3.003.184 3.866Zm5.287 0a1.708 1.708 0 0 1-2.243.888 1.699 1.699 0 0 1-.89-2.237c.373-.863 2.95-2.517 2.95-2.517s.557 3.003.183 3.866Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8ACBD",
  fillRule: "evenodd",
  d: "M6.79 14.616c-2.093 0-3.79-1.777-3.79-3.97 0-2.192 1.697-3.97 3.79-3.97.34 0 .666.051.979.139.638-1.975 2.405-3.402 4.496-3.445l.048-.003.048-.001c2.477 0 4.519 1.945 4.812 4.457.182-.033.368-.054.559-.054C19.537 7.77 21 9.302 21 11.192c0 1.891-1.463 3.424-3.268 3.424H6.79Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=RainIcon24.js.map